import { useEffect, useMemo, useState } from 'react';
import { checkConsent } from './check-consent';
import { onConsentChange } from './on-consent-change';
import type { CheckConsentOptions, ConsentCategory, UseConsentGatedResult } from './types';

export function useConsentGated(
  category: ConsentCategory,
  options?: CheckConsentOptions,
): UseConsentGatedResult {
  const [isGranted, setIsGranted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const stableOptions = useMemo(
    () => options,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [options?.pollIntervalMs, options?.timeoutMs],
  );

  useEffect(() => {
    let cancelled = false;

    checkConsent(category, stableOptions).then((granted) => {
      if (!cancelled) {
        setIsGranted(granted);
        setIsLoading(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [category, stableOptions]);

  useEffect(() => {
    const unsubscribe = onConsentChange((activeGroups) => {
      setIsGranted(activeGroups.includes(category));
    });

    return unsubscribe;
  }, [category]);

  return { isGranted, isLoading };
}
